import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fhirapis-segregation',
  templateUrl: './fhirapis-segregation.component.html'
 
})
export class FHIRApisSegregationComponent implements OnInit {

  constructor(public router: Router ) { 

    localStorage.setItem("is_cuurent_nav_aem","y");

  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  PublicPatientAccess(){
    localStorage.setItem("PublicViewAccess", "patientaccess");
    localStorage.setItem("PublicViewAccess2", "patientaccess");

    localStorage.setItem("api_display_text", "Patient Access and Payer-to-Payer APIs");
    this.router.navigate(['fhirapis']);
  }

  PublicProviderDirectoryApi(){
    localStorage.setItem("PublicViewAccess", "providerdirectory");
    localStorage.setItem("PublicViewAccess2", "providerdirectory");

    localStorage.setItem("api_display_text", "Provider Directory APIs");
    this.router.navigate(['fhirapis']);
  }


  ProviderAccessApi(){
    localStorage.setItem("PublicViewAccess", "provideraccess");
    localStorage.setItem("PublicViewAccess2", "cds-services");
    localStorage.setItem("api_display_text", "Provider Access and Prior Authorization APIs");
    this.router.navigate(['fhirapis']);
  }


}
